import { useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { PlenaLogo } from "../components/PlenaLogo";
import { Lock, MailCheck, Send, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.post("/auth/forgot-password", { email }); } catch (err) { /* always show success */ }
    setSent(true);
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#F5F5F7] dark:bg-[#161618] flex flex-col items-center justify-center px-6 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-[#007AFF]/10 blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full bg-[#30B0C7]/10 blur-3xl" />
      </div>
      <div className="relative w-full max-w-sm animate-fade-up">
        <div className="text-center mb-10">
          <div className="mb-7 flex justify-center"><PlenaLogo size="lg" /></div>
          <h1 className="text-2xl font-semibold tracking-tight text-slate-900 dark:text-white font-display">Şifrenizi mi unuttunuz?</h1>
          <p className="text-sm text-slate-500 mt-2">E-postanıza yeni şifre belirleme bağlantısı göndereceğiz</p>
        </div>
        <div className="bg-white/85 dark:bg-[#1C1C1E]/85 backdrop-blur-2xl rounded-2xl border border-white/60 dark:border-white/10 shadow-[0_8px_30px_rgb(0,0,0,0.06)] p-8">
          {sent ? (
            <div data-testid="forgot-password-success" className="text-center space-y-3">
              <div className="w-12 h-12 rounded-full bg-[#34C759]/10 text-[#34C759] flex items-center justify-center mx-auto"><MailCheck size={22} /></div>
              <p className="text-sm text-slate-600 dark:text-slate-300">Eğer <b>{email}</b> kayıtlıysa bağlantı gönderildi. Gelen kutunuzu (ve spam klasörünü) kontrol edin.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div>
                <label className="text-xs font-medium text-slate-500 uppercase tracking-wider">E-posta</label>
                <input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="ornek@firma.com"
                  className="mt-1.5 w-full h-11 px-4 rounded-xl bg-slate-100/80 dark:bg-white/10 border border-slate-200/60 dark:border-white/10 text-sm text-slate-900 dark:text-white placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-[#007AFF]/50 focus:bg-white dark:focus:bg-white/15 transition-all" />
              </div>
              <button data-testid="forgot-submit-button" type="submit" disabled={loading}
                className="w-full h-11 rounded-xl bg-[#0066CC] hover:bg-[#0052A3] active:scale-[0.98] text-white text-sm font-semibold transition-all shadow-lg shadow-[#0066CC]/25 disabled:opacity-60 flex items-center justify-center gap-2">
                {loading ? <span className="w-4 h-4 rounded-full border-2 border-white/40 border-t-white animate-spin" /> : <Send size={14} />} Bağlantı Gönder
              </button>
            </form>
          )}
        </div>
        <Link to="/login" data-testid="forgot-back-link" className="mt-6 text-sm font-medium text-slate-500 hover:text-slate-800 dark:hover:text-white flex items-center justify-center gap-1.5 transition-colors"><ArrowLeft size={13} /> Girişe dön</Link>
        <p className="text-center text-xs text-slate-400 mt-8 flex items-center justify-center gap-1.5"><Lock size={11} /> Plena.pro tarafından yönetilen güvenli alan</p>
      </div>
    </div>
  );
}
